"use client";

import { FC } from "react";
import ActualCard from "@/components/entities/news-card";
import Pager from "@/components/entities/pager";
import { useActualData } from "../../../hooks/useActualData";
import { useStore } from "@/hooks/system/useStore";
import ActualCardLoading from "@/components/entities/news-card/loading-card";
import { observer } from "mobx-react-lite";
import S from "./index.module.scss";

const ActualListContent: FC = () => {
  const { actual, actualLoading } = useActualData();

  const { selectedFilters, setSelectedFilters } = useStore("actual");

  const pageHandler = (page: number) => {
    setSelectedFilters({ pageNumber: page });
  };

  return (
    <>
      <div className={S.newsGrid}>
        {actualLoading
          ? new Array(12).fill({ id: 0 }).map((_, idx) => <ActualCardLoading key={idx} />)
          : actual?.articles?.map(item => <ActualCard key={item.id} actual={item} />)}
      </div>
      {actual && (
        <Pager
          activePageNumber={selectedFilters.pageNumber || 1}
          total={actual.total}
          activePageSize={selectedFilters.pageSize || 12}
          onPageChangeHandler={pageHandler}
        />
      )}
    </>
  );
};

export default observer(ActualListContent);
